import type { ChangeEvent } from 'react';
import { translate } from '../../i18n/translations';
import type { Language, Theme } from '../../platform/settings/settings';
import styles from './SettingsPanel.module.css';

type SettingsPanelProps = {
  language: Language;
  theme: Theme;
  onLanguageChange: (language: Language) => void;
  onThemeChange: (theme: Theme) => void;
};

export function SettingsPanel({
  language,
  theme,
  onLanguageChange,
  onThemeChange,
}: SettingsPanelProps) {
  const handleLanguageChange = (event: ChangeEvent<HTMLSelectElement>): void => {
    onLanguageChange(event.currentTarget.value as Language);
  };

  return (
    <section className={styles.panel} aria-label={translate(language, 'settings')}>
      <label className={styles.language}>
        <span>{translate(language, 'language')}</span>
        <select value={language} onChange={handleLanguageChange}>
          <option value="de">{translate(language, 'german')}</option>
          <option value="en">{translate(language, 'english')}</option>
        </select>
      </label>

      <fieldset className={styles.theme}>
        <legend>{translate(language, 'theme')}</legend>
        <div className={styles.themeOptions}>
          <label>
            <input
              type="radio"
              name="theme"
              value="light"
              checked={theme === 'light'}
              onChange={() => {
                onThemeChange('light');
              }}
            />
            <span>{translate(language, 'lightTheme')}</span>
          </label>
          <label>
            <input
              type="radio"
              name="theme"
              value="dark"
              checked={theme === 'dark'}
              onChange={() => {
                onThemeChange('dark');
              }}
            />
            <span>{translate(language, 'darkTheme')}</span>
          </label>
        </div>
      </fieldset>
    </section>
  );
}
